import React, { Component } from 'react';
import { Checkbox } from '@blueprintjs/core';
import { connect } from 'react-redux';
import { RenderDatePicker } from '../dashboard/modals/Base';
import { countries } from '../../../data/countries';
import moment from 'moment';
import citiesJSON from '../../../data/cities.json';
import FilterMultiSelect from '../../widgets/FilterMultiSelect';
import { getYearsArray } from '../../../helpers/functions';
import { loadStudentStatuses } from '../../../redux/actions/general.actions';

class ReconciliationFilter extends Component {
    constructor(props) {
        super(props);
        this.years = getYearsArray();
        this.options = this.years.map((v, i) => (<option key={i} value={v}>{v}</option>));
        this.cities = [];
        const startDate = new Date();
        startDate.setFullYear(startDate.getFullYear() - 1);
        this.state = {
            start_date: props.isDate ? startDate : this.years[1],
            end_date: props.isDate ? new Date() : this.years[0],
            countries: [],
            state_or_province: '',
            is_donor_assigned: 0,
            is_recipient_assigned: 0,
            recipient_student_status: ''
        }
    }
    async componentDidMount() {
        if (this.props.hasStudentStatus) {
            await this.props.loadStudentStatuses();
        }
        await this.loadData({ ...this.state });
    }
    loadData = () => {
        let city_of_school = '';
        let country_of_school = '';
        if (this.cities.length) {
            this.cities.forEach(city => {
                city_of_school += `&${this.props.isDate ? 'city_of_residence' : 'city_of_school'}=${city}`;
            });
        }
        if (this.state.countries.length) {
            this.state.countries.forEach(country => {
                country_of_school += `&country_of_school=${country}`;
            });
        }
        const start_date =  this.props.isDate ? moment(this.state.start_date).format('YYYY-MM-DD') : this.state.start_date;
        const end_date = this.props.isDate ? moment(this.state.end_date).format('YYYY-MM-DD') : this.state.end_date;
        this.props.loadData({ ...this.state, start_date, end_date, country_of_school, city_of_school});
    }
    handleDateChange = (value, type) => {
        this.setState({ [type]: value });
    }
    onCountryChange = (countries) => {
        this.setState({ countries });
    }
    onCityChange = (cityItems) => {
        this.cities = cityItems;
    }
    onChangeHandler = ({ text, value }) => {
        this.setState({ [value]: text });
    }
    onCheckBoxHandler = ({ value }) => {
        this.setState({ [value]: !this.state[value] });
    }
    render() {
        const { allLoading } = this.props;
        const { start_date, end_date } = this.state;
        let filteredCities = [];
        this.state.countries.forEach(country => {
            const countryCities = citiesJSON[country];
            if (countryCities) {
                filteredCities = filteredCities.concat(countryCities.map(city => ({ city, country })));
            }
        });
        return (
            <div className="reconciliation-filter">
                <div className="right-content">
                    <div className="filter-button">
                        <div className="filter-label"><strong>Start Date</strong></div>
                        { this.props.isDate ?
                            <RenderDatePicker
                                value={start_date}
                                datePicker
                                dateFormat="YYYY-MM-DD"
                                onChangeHandler={({ text }) => this.handleDateChange(text, 'start_date')} /> :
                            <div className="pt-select">
                                <select
                                    value={start_date}
                                    onChange={event => this.handleDateChange(event.target.value, 'start_date')}>
                                    {this.options}
                                </select>
                            </div>
                        }
                    </div>
                    <div className="filter-button">
                        <div className="filter-label"><strong>End Date</strong></div>
                        { this.props.isDate ?
                            <RenderDatePicker
                                value={end_date}
                                datePicker
                                noContainer
                                dateFormat="YYYY-MM-DD"
                                onChangeHandler={({ text }) => this.handleDateChange(text, 'end_date')} /> :
                            <div className="pt-select">
                                <select
                                    value={end_date}
                                    onChange={event => this.handleDateChange(event.target.value, 'end_date')}>
                                    {this.options}
                                </select>
                            </div>
                        }
                    </div>
                    <div className="filter-button">
                        <FilterMultiSelect items={countries}
                            placeholder="Search By Country..."
                            label="code"
                            id="name"
                            text="name"
                            onItemChange={this.onCountryChange} />
                    </div>
                    <div className="filter-button">
                        <FilterMultiSelect items={filteredCities}
                            placeholder="Search By City..."
                            noResultText="Start by selecting a city."
                            label="country"
                            id="city"
                            text="city"
                            onItemChange={this.onCityChange} />
                    </div>
                    { this.props.hasProvince ?
                        <div className="filter-button">
                            <input
                                className="pt-input"
                                placeholder="Search State/Province"
                                value={this.state.state_or_province}
                                onChange={({ target: {value}}) => this.onChangeHandler({ text: value, value: 'state_or_province'})} />
                        </div> : null
                    }
                    { this.props.hasStudentStatus && this.props.studentStatuses ?
                        <div className="pt-select" style={{ marginRight: 10 }}>
                            <select
                                value={this.state.recipient_student_status}
                                onChange={event => this.onChangeHandler({ text: event.target.value, value: 'recipient_student_status' })}>
                                <option value={0}>Student Status (Optional)</option>
                                { Object.keys(this.props.studentStatuses).map((key, i) => {
                                    return (
                                        <option key={i} value={key}>{this.props.studentStatuses[key]}</option>
                                    );
                                })}
                            </select>
                        </div> : null }
                    { this.props.hasRecipientAssigned ?
                        <div className="pt-select" style={{ marginRight: 10 }}>
                            <select
                                value={this.state.is_recipient_assigned}
                                onChange={event => this.onChangeHandler({ text: event.target.value, value: 'is_recipient_assigned' })}>
                                <option value={0}>Is Recipient Assigned (Optional)</option>
                                <option value={'true'}>Recipient Assigned</option>
                                <option value={'false'}>Recipient Not Assigned</option>
                            </select>
                        </div> : null
                    }
                    { this.props.hasDonorAssigned ?
                        <div className="pt-select" style={{ marginRight: 10 }}>
                            <select
                                value={this.state.is_donor_assigned}
                                onChange={event => this.onChangeHandler({ text: event.target.value, value: 'is_donor_assigned' })}>
                                <option value={0}>Is Donor Assigned (Optional)</option>
                                <option value={'true'}>Donor Assigned</option>
                                <option value={'false'}>Donor Not Assigned</option>
                            </select>
                        </div> : null
                    }
                    <div className="filter-button">
                        <Checkbox checked={this.props.checkAll} label={"Select all"} onChange={this.props.onCheckAll} />
                    </div>
                    <button className="pt-button pt-intent-primary pt-icon-search"
                        onClick={this.loadData}
                        disabled={allLoading}>
                        {allLoading ? 'Searching...' : 'Search'}
                    </button>
                </div>
                {this.props.actionButton ? this.props.actionButton : null}
            </div>
        );
    }
}

export default connect(
    (state) => ({
        studentStatuses: state.general.studentStatuses
    }),
    { loadStudentStatuses }
)(ReconciliationFilter);



// WEBPACK FOOTER //
// ./src/components/main/common/ReconciliationFilter.jsx